import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import PlaceIcon from '@mui/icons-material/Place'
import { MonitoringSiteItem } from './MonitoringSiteItem'

interface ManualSitesSectionProps {
  manualSites: Array<{
    properties: {
      id?: string | number
      name: string
      newManualSite?: boolean
    }
    geometry: {
      coordinates: [number, number]
    }
  }>
  wasSaved: boolean
  isViewOnly: boolean
  onNameChange: (index: number, newName: string) => void
  onDelete: (index: number) => void
  onAddManualSite: () => void
}

export const ManualSitesSection = ({
  manualSites,
  wasSaved,
  isViewOnly,
  onNameChange,
  onDelete,
  onAddManualSite,
}: ManualSitesSectionProps) => {
  const hasManualSites = manualSites && manualSites.length > 0

  return (
    <>
      {hasManualSites && (
        <Box sx={{ py: 2 }}>
          {/* Header */}
          <Stack
            alignItems="center"
            direction="row"
            spacing={2}
            sx={{ p: 1, mb: 1, justifyContent: 'space-between' }}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              {/* PlaceIcon para sitios manuales */}
              <PlaceIcon sx={{ color: '#3a9dff', fontSize: 28 }} />
              <Typography fontWeight={600} variant="accordionTitle">
                Sitios Manuales ({manualSites.length})
              </Typography>
            </Stack>
            <Button
              color="primary"
              disabled={isViewOnly}
              size="small"
              startIcon={<AddIcon sx={{ fontSize: 22 }} />}
              sx={{ fontWeight: 600, textTransform: 'none', minWidth: 0 }}
              variant="outlined"
              onClick={onAddManualSite}
            >
              AGREGAR
            </Button>
          </Stack>

          {/* Lista de sitios */}
          {manualSites.map((monitoringSite, index) => (
            <MonitoringSiteItem
              key={monitoringSite.properties.id || monitoringSite.properties.name}
              isRandomSite={false}
              monitoringSite={monitoringSite}
              wasSaved={wasSaved}
              onDelete={() => onDelete(index)}
              onNameChange={newName => onNameChange(index, newName)}
            />
          ))}
          <Box sx={{ px: 2, py: 1 }} />
        </Box>
      )}

      {/* Botón para agregar sitio manual cuando no hay sitios manuales */}
      {!hasManualSites && (
        <Box
          sx={{
            alignItems: 'center',
            padding: '20px',
            textAlign: 'center',
          }}
        >
          <Tooltip title="Agregar sitio manual">
            <Button
              disabled={isViewOnly}
              size="small"
              startIcon={<AddIcon />}
              variant="outlined"
              onClick={onAddManualSite}
            >
              Agregar Sitio Manual
            </Button>
          </Tooltip>
        </Box>
      )}
    </>
  )
}
